/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { WebhookEventCreateRequestBaseResponse as ModelsWebhookWebhookEventCreateRequestBaseResponse } from '../models/Models/Webhook/webhook-event-create-request-base-response';
import { WebhookEventNotificationResponseBaseBaseResponse as ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse } from '../models/Models/Webhook/webhook-event-notification-response-base-base-response';
import { v3WebhooksCallbacktestPost$Json } from '../fn/webhooks/v-3-webhooks-callbacktest-post-json';
import { V3WebhooksCallbacktestPost$Json$Params } from '../fn/webhooks/v-3-webhooks-callbacktest-post-json';
import { v3WebhooksCallbacktestPost$Plain } from '../fn/webhooks/v-3-webhooks-callbacktest-post-plain';
import { V3WebhooksCallbacktestPost$Plain$Params } from '../fn/webhooks/v-3-webhooks-callbacktest-post-plain';
import { v3WebhooksDeregisterDelete$Json } from '../fn/webhooks/v-3-webhooks-deregister-delete-json';
import { V3WebhooksDeregisterDelete$Json$Params } from '../fn/webhooks/v-3-webhooks-deregister-delete-json';
import { v3WebhooksDeregisterDelete$Plain } from '../fn/webhooks/v-3-webhooks-deregister-delete-plain';
import { V3WebhooksDeregisterDelete$Plain$Params } from '../fn/webhooks/v-3-webhooks-deregister-delete-plain';
import { v3WebhooksDeregisterDelete$Xml } from '../fn/webhooks/v-3-webhooks-deregister-delete-xml';
import { V3WebhooksDeregisterDelete$Xml$Params } from '../fn/webhooks/v-3-webhooks-deregister-delete-xml';
import { v3WebhooksRegisterPost$Json$Json } from '../fn/webhooks/v-3-webhooks-register-post-json-json';
import { V3WebhooksRegisterPost$Json$Json$Params } from '../fn/webhooks/v-3-webhooks-register-post-json-json';
import { v3WebhooksRegisterPost$Json$Plain } from '../fn/webhooks/v-3-webhooks-register-post-json-plain';
import { V3WebhooksRegisterPost$Json$Plain$Params } from '../fn/webhooks/v-3-webhooks-register-post-json-plain';
import { v3WebhooksRegisterPost$Json$Xml } from '../fn/webhooks/v-3-webhooks-register-post-json-xml';
import { V3WebhooksRegisterPost$Json$Xml$Params } from '../fn/webhooks/v-3-webhooks-register-post-json-xml';
import { v3WebhooksRegisterPost$Xml$Json } from '../fn/webhooks/v-3-webhooks-register-post-xml-json';
import { V3WebhooksRegisterPost$Xml$Json$Params } from '../fn/webhooks/v-3-webhooks-register-post-xml-json';
import { v3WebhooksRegisterPost$Xml$Plain } from '../fn/webhooks/v-3-webhooks-register-post-xml-plain';
import { V3WebhooksRegisterPost$Xml$Plain$Params } from '../fn/webhooks/v-3-webhooks-register-post-xml-plain';
import { v3WebhooksRegisterPost$Xml$Xml } from '../fn/webhooks/v-3-webhooks-register-post-xml-xml';
import { V3WebhooksRegisterPost$Xml$Xml$Params } from '../fn/webhooks/v-3-webhooks-register-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class WebhooksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3WebhooksRegisterPost()` */
  static readonly V3WebhooksRegisterPostPath = '/v3/webhooks/register';

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksRegisterPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksRegisterPost$Json$Plain$Response(params?: V3WebhooksRegisterPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksRegisterPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksRegisterPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksRegisterPost$Json$Plain(params?: V3WebhooksRegisterPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksRegisterPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksRegisterPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksRegisterPost$Json$Json$Response(params?: V3WebhooksRegisterPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksRegisterPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksRegisterPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksRegisterPost$Json$Json(params?: V3WebhooksRegisterPost$Json$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksRegisterPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksRegisterPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksRegisterPost$Json$Xml$Response(params?: V3WebhooksRegisterPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksRegisterPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksRegisterPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksRegisterPost$Json$Xml(params?: V3WebhooksRegisterPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksRegisterPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksRegisterPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3WebhooksRegisterPost$Xml$Plain$Response(params?: V3WebhooksRegisterPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksRegisterPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksRegisterPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3WebhooksRegisterPost$Xml$Plain(params?: V3WebhooksRegisterPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksRegisterPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksRegisterPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3WebhooksRegisterPost$Xml$Json$Response(params?: V3WebhooksRegisterPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksRegisterPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksRegisterPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3WebhooksRegisterPost$Xml$Json(params?: V3WebhooksRegisterPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksRegisterPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksRegisterPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3WebhooksRegisterPost$Xml$Xml$Response(params?: V3WebhooksRegisterPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksRegisterPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Register event's callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksRegisterPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v3WebhooksRegisterPost$Xml$Xml(params?: V3WebhooksRegisterPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksRegisterPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3WebhooksDeregisterDelete()` */
  static readonly V3WebhooksDeregisterDeletePath = '/v3/webhooks/deregister';

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksDeregisterDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3WebhooksDeregisterDelete$Plain$Response(params?: V3WebhooksDeregisterDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksDeregisterDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksDeregisterDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3WebhooksDeregisterDelete$Plain(params?: V3WebhooksDeregisterDelete$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksDeregisterDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksDeregisterDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3WebhooksDeregisterDelete$Json$Response(params?: V3WebhooksDeregisterDelete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksDeregisterDelete$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksDeregisterDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3WebhooksDeregisterDelete$Json(params?: V3WebhooksDeregisterDelete$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksDeregisterDelete$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksDeregisterDelete$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3WebhooksDeregisterDelete$Xml$Response(params?: V3WebhooksDeregisterDelete$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
    return v3WebhooksDeregisterDelete$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Deregister callback.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksDeregisterDelete$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3WebhooksDeregisterDelete$Xml(params?: V3WebhooksDeregisterDelete$Xml$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventCreateRequestBaseResponse> {
    return this.v3WebhooksDeregisterDelete$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>): ModelsWebhookWebhookEventCreateRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v3WebhooksCallbacktestPost()` */
  static readonly V3WebhooksCallbacktestPostPath = '/v3/webhooks/callbacktest';

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksCallbacktestPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksCallbacktestPost$Plain$Response(params?: V3WebhooksCallbacktestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>> {
    return v3WebhooksCallbacktestPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksCallbacktestPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksCallbacktestPost$Plain(params?: V3WebhooksCallbacktestPost$Plain$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse> {
    return this.v3WebhooksCallbacktestPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>): ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse => r.body)
    );
  }

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3WebhooksCallbacktestPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksCallbacktestPost$Json$Response(params?: V3WebhooksCallbacktestPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>> {
    return v3WebhooksCallbacktestPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Test event's callback.
   *
   * If the webhook callback was created with a Secret, only the UnixTimestamp property will be HMAC hashed with the secret (not the entire response payload).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3WebhooksCallbacktestPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v3WebhooksCallbacktestPost$Json(params?: V3WebhooksCallbacktestPost$Json$Params, context?: HttpContext): Observable<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse> {
    return this.v3WebhooksCallbacktestPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>): ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse => r.body)
    );
  }

}
